import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import appConfig from '../../appConfig';

function NavMenuOption(props) {
  return (
    appConfig.displayNavBarLabels ?
      <div>
        {props.children}
        <span className="nav-options__title">
          {props.navLabel}
        </span>
      </div> :
      <OverlayTrigger
        placement="bottom"
        overlay={
          <Tooltip id="tooltip-disabled">
            {props.navLabel}
          </Tooltip>
        }
      >
        {props.children}
      </OverlayTrigger>
  );
}

NavMenuOption.propTypes = {
  navLabel: PropTypes.string,
};

export default injectIntl(NavMenuOption);



// WEBPACK FOOTER //
// ./src/js/components/Nav/NavMenuOption.jsx